import { render, staticRenderFns } from "./ModaFormComponent.vue?vue&type=template&id=104288ee"
import script from "./ModaFormComponent.vue?vue&type=script&lang=js"
export * from "./ModaFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports